
import pageStore from '@/shared/content/page.store';
import { defineComponent } from 'vue';
import { map } from 'lodash';
export default defineComponent({
    name: 'SiteLayout',
    setup(props, { slots }) {
        if (!slots) {
            throw new Error('You must provide at least 1 layout slot');
        }
        return () => {
            const visibleSlots = map(slots, (slot, key: string) => {
                const keysAsArray = key.split(',').map(k => k.trim());
                const visible = keysAsArray.indexOf(pageStore.siteLayoutName) > -1;
                return {
                    visible,
                    slot,
                };
            }).filter(x => x.visible).map(x => x.slot);
            return visibleSlots.length ? visibleSlots![0]() : undefined;
        };
    },
});
